module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'fa ' + _vm.fasquare,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSquare($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2094d1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/filterChecksquare.vue
// module id = 3946
// module chunks = 1